import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { GradeLevel } from '@app/infrastructure/models/grade-level';

import {
  GradeUnitListItemDTO,
  IGradeUnitListItemDTO,
} from '@models/grade-unit/grade-unit';
import { IPermissionCheck, PermissionCheck } from '@models/role';
import { StatusEnum } from '@models/status';

@Component({
  selector: 'app-grade-unit-presentation',
  templateUrl: './grade-unit-presentation.component.html',
  styleUrls: ['./grade-unit-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitPresentationComponent {
  @Input() public gradeUnit: IGradeUnitListItemDTO = new GradeUnitListItemDTO();
  @Input() public checkPermission: IPermissionCheck = new PermissionCheck();
  @Input() public showUnitNumber: boolean = true;

  @Output() public emitNavigateToDayList = new EventEmitter<{
    grade: GradeLevel;
    unit: number;
  }>();

  public statusEnum = StatusEnum;

  public checkStatus(status: StatusEnum): {
    pending: boolean;
    ready: boolean;
  } {
    return {
      pending: status === StatusEnum.PENDING,
      ready: status === StatusEnum.READY,
    };
  }

  public getNGSSDescription() {
    if (
      !this.gradeUnit.unitNGSSMetricNumber ||
      !this.gradeUnit.unitNGSSMetricNumber
    )
      return;
    return `${this.gradeUnit.unitNGSSMetricNumber}: ${this.gradeUnit.unitNGSSMetricDescription}`;
  }

  public getAltText(unitNumber: number): string {
    return `Unit ${unitNumber} Cover Photo`;
  }

  public navigateToDayList(grade: GradeLevel, unit: number): void {
    this.emitNavigateToDayList.emit({ grade, unit });
  }
}
